<template lang="pug">
button.scroll(
  @click="$emit('click')"
  v-if="isShow"
)
  ArrowDownIcon
</template>

<script>
import ArrowDownIcon from '@/assets/images/bi_arrow-down.svg'

export default {
  name: 'BaseBtnScroll',
  components: {
    ArrowDownIcon,
  },
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style>
.scroll {
  position: fixed;
  bottom: 90px;
  right: 20px;
  z-index: 10;
  padding: 6px 0;
  outline: none;
  border: none;
  background-color: #c4c4c4;
  border-radius: 5px;
}
</style>
